import React from 'react';
import PropTypes from 'prop-types';
import Divider from '../Divider/Divider';
import Header from './Header';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TableHead = function TableHead(_ref) {
  var headers = _ref.headers,
    dataTestId = _ref.dataTestId;
  return ___EmotionJSX("thead", {
    "data-test-id": "table-head-" + dataTestId
  }, ___EmotionJSX("tr", {
    style: {
      padding: '8px 16px'
    }
  }, headers.map(function (header, index) {
    return ___EmotionJSX(Header, {
      key: header.id,
      header: header,
      isFirst: index === 0,
      isLast: index === headers.length - 1,
      dataTestId: dataTestId
    });
  })), ___EmotionJSX(Divider, {
    light: true
  }));
};
var headerPropsTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  width: PropTypes.number
});
TableHead.propTypes = {
  headers: PropTypes.arrayOf(headerPropsTypes).isRequired,
  dataTestId: PropTypes.string
};
export default TableHead;